import { INodeCreate, INodePositionUpdate, INodeUpdate, IOrganizationChartNode } from '../../resource/node/node.types';
import { IChart } from '../../resource/chart/chart.types';
import { IApiRequestConfig } from '../api.types';

export type GetChartOptions = {
  chartId?: IChart['id'];
  scope?: 'published' | 'draft';
};

export const getChartApi = (chartType: string, options?: GetChartOptions): IApiRequestConfig<unknown> => {
  let action = `charts/${chartType}`;
  if (options?.chartId) {
    action += `/${options.chartId}`;
  } else if (options?.scope === 'draft') {
    action += '/draft';
  } else {
    action += '/published';
  }

  return {
    apiRouteKey: 'getChart',
    uri: 'json',
    action,
    method: 'get',
    v2: true,
  };
};

export const listChartVersionsApi = (chartType: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'listChartVersions',
  uri: 'json',
  action: `charts/${chartType}/versions`,
  method: 'get',
  v2: true,
});

export const publishChartVersionApi = (
  chartType: string,
  chartId: IChart['id'],
): IApiRequestConfig<{ chartId: IChart['id'] }> => ({
  apiRouteKey: 'publishChartVersion',
  uri: 'json',
  action: `charts/${chartType}/versions/republish`,
  method: 'post',
  data: { chartId },
  v2: true,
});

export const publishDraftChartApi = (chartType: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'publishDraftChart',
  uri: 'json',
  action: `charts/${chartType}/drafts/publish`,
  method: 'post',
  v2: true,
});

export const createEmptyDraftApi = (chartType: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createEmptyDraft',
  uri: 'json',
  action: `charts/${chartType}/drafts`,
  method: 'post',
  v2: true,
});

export const createDraftFromVersionApi = (
  chartType: string,
  sourceChartId: IChart['id'],
): IApiRequestConfig<{ sourceChartId: IChart['id'] }> => ({
  apiRouteKey: 'createDraftFromVersion',
  uri: 'json',
  action: `charts/${chartType}/drafts/from-version`,
  method: 'post',
  data: { sourceChartId },
  v2: true,
});

export const deleteChartApi = (chartType: string, chartId: IChart['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteChart',
  uri: 'json',
  action: `charts/${chartType}/${chartId}`,
  method: 'delete',
  v2: true,
});

export const createNodeApi = (data: INodeCreate, chartType: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createNode',
  uri: 'json',
  action: `charts/${chartType}/nodes`,
  method: 'post',
  data,
  v2: true,
});

export const updateNodeApi = (nodeId: IOrganizationChartNode['id'], data: INodeUpdate): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateNode',
  uri: 'json',
  action: `nodes/${nodeId}`,
  method: 'patch',
  data,
  v2: true,
});

export const updateNodesPositionsApi = (
  chartType: string,
  data: { nodes: INodePositionUpdate[] },
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'updateNodesPositions',
  uri: 'json',
  action: `charts/${chartType}/nodes/positions`,
  method: 'patch',
  data,
  v2: true,
});

export const deleteNodeApi = (nodeId: IOrganizationChartNode['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deleteNode',
  uri: 'json',
  action: `nodes/${nodeId}`,
  method: 'delete',
  v2: true,
});
